module.exports = __webpack_public_path__ + "static/media/grid.active.f4780a54.svg";